import React, { FunctionComponent, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { NoiseCancellationType } from '../../../../../../../../../../common/types/settings';
import { i18n } from '../../../../../../../helpers/i18n';
import { countMetrika } from '../../../../../../../helpers/metrika';
import { useActions } from '../../../../../../../hooks';
import { selectIsNoiseCancellationEnabled, selectNoiseCancellationType } from '../../../../../../settings/selectors';
import { setNoiseCancellationTypeAction } from '../../../../../../settings/slice';
import { SettingsTumbler } from '../../../tumblers';

export const NoiseCancellationTumbler: FunctionComponent = () => {
    const { setNoiseCancellationType } = useActions({
        setNoiseCancellationType: setNoiseCancellationTypeAction,
    });

    const noiseCancellationType = useSelector(selectNoiseCancellationType);
    const isNoiseCancellationEnabled = useSelector(selectIsNoiseCancellationEnabled);

    const noiseCancellationActive = useMemo(
        () => noiseCancellationType !== NoiseCancellationType.DISABLED,
        [noiseCancellationType]
    );

    if (!isNoiseCancellationEnabled) {
        return null;
    }

    const onChange = () => {
        const opposite =
            noiseCancellationType === NoiseCancellationType.DISABLED
                ? NoiseCancellationType.AUTO
                : NoiseCancellationType.DISABLED;

        countMetrika('meeting_screen', 'noise_cancellation', 'user', opposite);
        setNoiseCancellationType(opposite);
    };

    return (
        <SettingsTumbler
            checked={noiseCancellationActive}
            aria-label={i18n('settings-v2', 'sound-speaker')}
            testId="noise-cancellation-tumbler"
            onChange={onChange}
            label={i18n('settings-v2', 'sound-noise-cancellation')}
        />
    );
};
